import { createRoot } from 'react-dom/client';
import type { Metric } from 'web-vitals';

import App from './App';
import './index.css';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

const reportWebVitals = (metric: Metric) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }
};

import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
  onCLS(reportWebVitals);
  onFCP(reportWebVitals);
  onLCP(reportWebVitals);
  onTTFB(reportWebVitals);
});
